export default {
    name: "UserManage",
    data() {
        return {
            searchForm: {
                name: '',
                isEnable: null,
                page: 1,
                pageSize: 50
            },
            tableData: [],
            selected: [],
            total: 0
        }
    },
    created(){
        this.init();
    },
    methods: {
        init(){
            let conditionParam = this.$routerUtil.getParam();
            if(conditionParam && conditionParam.searchForm){
                conditionParam = conditionParam.searchForm;
            }
            this.$routerUtil.clearParam();
            if(conditionParam){
                this.$nextTick(() => {
                    this.searchForm = conditionParam;
                    this.doSearch();
                });
            }
        },
        handleSizeChange(val){
            this.searchForm.pageSize = val;
            this.doSearch();
        },
        handleCurrentChange(val){
            this.searchForm.page = val;
            this.doSearch();
        },
        handleSelectionChange(val) {
            this.selected = val;
        },
        rowClick(row){
            this.$refs.table.toggleRowSelection(row);
        },
        doSearch() {
            const param = this.$paramUtil.clearEmpty(this.searchForm);
            param.systemCode = JSON.parse(sessionStorage.getItem('currentSystem')).code;
            this.$axios.get('/api/accounts/accountManage', {params: param}).then(response => {
                this.tableData = response.data.resultData.rows;
                this.total = response.data.resultData.total;
                this.selected = [];
            }).catch(e => {
                console.log(e);
                this.$message({
                    message: this.$t('common.message.operateFail'),
                    type: 'error',
                    center: true
                });
            });
        },
        doDetail(){
            const row = this.getSelectedRow();
            if (row) {
                const data = {};
                data.searchForm = this.searchForm;
                data.data = row;
                this.$routerUtil.setParam(data);
                this.$router.push('user-detail');
            }
        },
        doEdit(){
            const row = this.getSelectedRow();
            if (row) {
                const data = {};
                data.searchForm = this.searchForm;
                data.data = row;
                this.$routerUtil.setParam(data);
                this.$router.push('user-edit');
            }
        },
        doDisable(){
            this.doStateUpdate(0);
        },
        doEnable(){
            this.doStateUpdate(1);
        },
        doStateUpdate(state) {
            if (this.selected.length < 1) {
                this.$message({
                    message: this.$t('common.message.atLastOneRow'),
                    type: 'warning',
                    center: true
                });
                return
            }
            if (this.selected.length > 1) {
                this.$message({
                    message: this.$t('common.message.onlyOneRow'),
                    type: 'warning',
                    center: true
                });
                return null
            }
            const param = {};
            const enableAccountList = [];
            this.selected.forEach(row => {
                const paramRow = {};
                paramRow.id = row.id;
                paramRow.version = row.version;
                paramRow.isEnable = state;
                paramRow.userAccount = row.userAccount;
                enableAccountList.push(paramRow);
            });
            param.enableAccountList = enableAccountList;
            this.$axios.put('/api/accounts/enableAccount', param).then(response => {
                let type = 'error';
                if (response.data.status === '1') {
                    type = 'success';
                    this.doSearch();
                }
                this.$message({
                    message: this.$t(response.data.message),
                    type: type,
                    center: true
                });
            }).catch(e => {
                console.log(e);
                this.$message({
                    message: this.$t('common.message.operateFail'),
                    type: 'error',
                    center: true
                });
            })
        },
        doReset() {
            this.$refs.form.resetFields();
        },
        getSelectedRow(){
            if (this.selected.length > 1) {
                this.$message({
                    message: this.$t('common.message.onlyOneRow'),
                    type: 'warning',
                    center: true
                });
                return null
            }
            if (this.selected.length < 1) {
                this.$message({
                    message: this.$t('common.message.atLastOneRow'),
                    type: 'warning',
                    center: true
                });
                return null
            }
            if(!this.selected[0]){
                this.$message({
                    message: this.$t('common.message.atLastOneRow'),
                    type: 'warning',
                    center: true
                });
                return null
            }
            return this.selected[0];
        }
    }
}
